import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $InvoiceSvgItem = styled.div`
  position: relative;
  display: block;
  width: ${spacing(44)};
  svg {
    color: ${({ theme }) => theme.newUI.defaultColors.menu};
  }
`;

export const $InvoiceSvgLogo = styled.div`
  position: absolute;
  top: ${spacing(5)};
  left: ${spacing('xxl')};
  width: ${spacing(16)};
`;

export const $HasNotInvoiceIconsContainer = styled.div`
  display: flex;
  align-items: center;
  width: ${spacing(20)};
  height: ${spacing(10)};
`;
